import styled from "styled-components";
import HomeComponent from "./modules/home";
import OverviewComponent from "./modules/home/OverviewComponent";
import TransactionComponent from "./modules/home/TransactionComponent";
const Container =styled.div`
display:flex;
flex-direction:column;
align-items: center;
margin: 30px 0 10px;
font-family: 'Poppins', sans-serif;


`;
const Header =styled.span`
color:black;
fontsize:25px;
font-weight:bold;
`
function App() {
  return <Container>
    <Header>XPENDER</Header>
    <HomeComponent/>
  </Container>
};

export default App;
